<script>
import { tick } from 'svelte';
import { Delta } from '@typewriter/editor';
import { deltaToHTML } from '@typewriter/view-vdom';
import { getPaper, sanitizeDelta } from '../editor';
import { user } from '../data/user';
import { userLookup } from '../data/server';

export let messages = [];
export let disabled = false;
const paper = getPaper();
paper.blocks.remove('header');
paper.blocks.remove('blockquote');
let scrollBox;

$: keepScrollDown(messages);
$: uid = $user && $user.uid;
$: checkForNewNames(messages);

function checkForNewNames(messages) {
  messages.forEach(msg => {
    if (!$userLookup[msg.uid]) {
      userLookup.lookup(msg.uid);
    }
  })
}

async function keepScrollDown() {
  if (!scrollBox) return;
  const scrollBottom = scrollBox.scrollTop + scrollBox.offsetHeight;
  const lastMessageMine = messages.length && messages[messages.length - 1].uid === uid;
  const atBottom = lastMessageMine || scrollBox.scrollHeight - scrollBottom <= 4;
  if (atBottom) {
    await tick();
    scrollBox.scrollTop = scrollBox.scrollHeight;
  }
}

</script>

<div bind:this={scrollBox} class="messages" class:disabled>
  {#if !disabled}
  <div class="system-msg">Chat with your fellow participants. Be respectful, have fun!</div>
  {/if}
  {#each messages as message, i}
  <div class="msg" data-name={!i || message.uid !== messages[i - 1].uid ? ($userLookup[message.uid] && $userLookup[message.uid].name) || '' : null} class:mine={message.uid === uid}>
    {@html deltaToHTML(sanitizeDelta(new Delta(message.content)), paper)}
  </div>
  {/each}
</div>

<style>
.messages {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: #fff;
  flex: 1;
  padding: 8px;
  overflow-y: scroll;
}
.messages.disabled {
  background: var(--warm-grey-050);
}
.system-msg {
  text-align: center;
  margin: 0 0 12px;
  font-size: var(--font-size-050);
  color: var(--warm-grey-400);
}
.msg {
  position: relative;
  margin-top: 4px;
  margin-right: 24px;
  padding: 4px 8px;
  border-radius: 11px;
  background: var(--warm-grey-100);
  color: var(--warm-grey-800);
  font-size: var(--font-size-100);
  overflow-wrap: break-word;
  word-break: break-word;
  page-break-before: always;
}
.msg[data-name]:not(.mine) {
  margin-top: 20px;
}
.msg:not(.mine)::before {
  position: absolute;
  content: attr(data-name);
  height: 0;
  margin-top: -16px;
  font-size: var(--font-size-040);
  color: var(--warm-grey-400);
  width: 180px;
}
.msg.mine {
  background: var(--blue-500);
  color: var(--white);
  margin-right: 0;
  margin-left: 24px;
  align-self: flex-end;
}
.messages :global(a) {
	text-decoration: underline;
}
.msg.mine :global(a) {
  color: #fff;
}
.messages :global(p) {
  margin: 0;
}
.messages :global(blockquote) {
  margin: 0 0 0 4px;
  padding: 0 0 0 8px;
  border-left: 1px solid var(--warm-grey-300);
}
</style>
